import { memo, Suspense } from 'react';

import ModalAssignment from '@/lib/v2/organisms/ModalAssignment';

import { useTagsByContacts } from '@/src/ContactsModule/hooks/useTagsByContacts';
import { ITag, IUpdateItemsToPropsV2 } from '@/src/ContactsModule/interfaces/Interfaces';

interface ContactsTagsAssignmentModalProps {
  isOpen: boolean;
  onClose: (value: boolean) => void;
  selectedContacts: number[];
  tags: ITag[];
  onAssignment: ({
    selectedContacts,
    selectedItems,
    unselectedItems,
  }: IUpdateItemsToPropsV2) => Promise<void>;
  selectAllResults: boolean;
  onLastRefresh?: () => void;
  allContactsCount: number;
  isLoading?: boolean;
  maxTagsToAdd?: number;
}

const ContactsTagsAssignmentModal = ({
  isOpen,
  onClose,
  selectedContacts,
  tags,
  onAssignment,
  selectAllResults,
  onLastRefresh,
  allContactsCount,
  isLoading,
  maxTagsToAdd,
}: ContactsTagsAssignmentModalProps) => {
  const { wordings, onApply, handleOnCreate } = useTagsByContacts({
    selectedContacts,
    selectAllResults,
    onAssignment,
    onLastRefresh,
    allContactsCount,
  });

  const items = tags.map((tag) => ({
    id: tag.id,
    name: tag.name,
  }));

  return (
    <Suspense>
      <ModalAssignment
        isLoading={isLoading}
        isOpen={isOpen}
        items={items}
        limitSelection={maxTagsToAdd}
        onClose={onClose}
        onCreate={handleOnCreate}
        wordings={wordings}
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onApply={(e, selected, unselected) =>
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          onApply({ selectedContacts, selectedItems: selected, unselectedItems: unselected })
        }
      />
    </Suspense>
  );
};

export default memo(ContactsTagsAssignmentModal);
